<template>
  <div>
    <div class="col-xl-12 col-lg-12 col-md-12 card-content">
      <div class="info-personal" id="informacionPersonalLink"></div>
      <transition name="fade" mode="out-in">
        <Statistics
          v-if="state === 2"
          :id="$route.params.id"
          :obstats="obstats"
        ></Statistics>
      </transition>
      <div class="card card-style">
        <div ref="alert"></div>
        <div v-for="user in infoPersonal" :key="user.id" class="card-body">
          <div class="d-flex justify-content-between">
            <div class="title_edit_container mb-2 mt-2">
              <div class="subtitle_useram">
                {{ $t('message.ei_personal_info_title') }}
              </div>
            </div>
            <div
              class="d-flex align-items-center"
              v-show="!isEditingDoc && !isEditingParent"
            >
              <div v-if="disabledInfoPersonal" class="m-portlet__head-caption">
                <button
                  @click.prevent="disabledPersonal"
                  class="btn btn-secondary mr-4"
                  data-vs-button="disable-personal"
                >
                  {{ $t('message.ob_submit_swal_reject') }}
                </button>
                <button
                  v-if="!isLoading"
                  @click.prevent="handleButtonInfoPersonal"
                  type="submit"
                  class="btn btn-primary ml-0 mr-0"
                  data-vs-button="info-personal"
                >
                  {{ $t('message.ei_personal_info_save_changes') }}
                </button>
                <button
                  data-vs-button="info-personal"
                  v-if="isLoading"
                  class="btn btn-primary ml-0 mr-0"
                >
                  <div class="m-loader m-loader--light"></div>
                </button>
              </div>
            </div>
          </div>
          <hr />
          <div class="">
            <form data-vs-form="form-levels">
              <div
                v-for="section in filterSection('RRHH')"
                class=""
                :key="section.id"
              >
                <ul class="m-nav">
                  <li>
                    <div v-for="item in section.levels" :key="item.id">
                      <div
                        v-if="item.fields[0].name == 'celular'"
                        class="second_subtitle_useram mb-0 mt-0 ml-0"
                      >
                        {{ $t('message.ei_titleList_text_2') }}
                      </div>
                      <div
                        v-if="item.fields[0].name === 'usa_cbu'"
                        class="second_subtitle_useram mb-0 mt-4 ml-0"
                      >
                        {{ $t('message.ei_titleList_text_5') }}
                      </div>
                      <div
                        v-if="
                          item.fields[0].name === 'calle' ||
                          item.fields[0].name === 'domicilio_tipo_domicilio'
                        "
                        class="second_subtitle_useram mb-0 mt-4 ml-0"
                      >
                        {{ $t('message.ei_titleList_text_3') }}
                      </div>
                      <div
                        v-if="
                          item.fields[0].name === 'section_personales_genero'
                        "
                        class="second_subtitle_useram mb-0 mt-4 ml-0"
                      >
                        {{ $t('message.ei_titleList_text_6') }}
                      </div>
                      <div
                        class="mt-4 mb-3 row"
                        :class="
                          item.fields[0].name === 'usa_cbu'
                            ? 'd-flex align-items-center'
                            : ''
                        "
                      >
                        <div
                          v-for="field in item.fields"
                          class="col-lg-6 group-inputs-label mt-3"
                          v-if="
                            field.name !== 'section_personales_tipo_documento'
                          "
                          :class="
                            field.type === 'aplica'
                              ? 'd-flex align-self-center'
                              : ''
                          "
                          :key="field.id"
                        >
                          <div v-if="field.name === 'celular'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  'celular',
                                  'celularTexting',
                                  field
                                )
                              "
                              @keyup="
                                handleChangeInfo(
                                  'celular',
                                  'celularTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              id="celular"
                              name="celular"
                              v-model="field.value"
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              :required="celularTexting"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('celular')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div v-if="field.name === 'cbu'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo('cbu', 'cbuTexting', field)
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo('cbu', 'cbuTexting', field)
                              "
                              class="input_styles"
                              type="number"
                              id="cbu"
                              name="cbu"
                              v-model="field.value"
                              :required="cbuTexting"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('cbu')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div v-if="field.name === 'celular_emergencia'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  'celular_emergencia',
                                  'emergenciaTexting',
                                  field
                                )
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo(
                                  'celular_emergencia',
                                  'emergenciaTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              id="celular_emergencia"
                              name="celular_emergencia"
                              v-model="field.value"
                              :required="emergenciaTexting"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias | capitalize }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('celular_emergencia')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div v-if="field.name === 'usa_cbu'">
                            <label
                              class="mb-0 m-checkbox m-checkbox--bold m-checkbox--state-success"
                              :disabled="
                                (!disabledInfoPersonal &&
                                  employeeState !== 2) ||
                                hasIntengrationSichernPeople
                              "
                            >
                              <input
                                :data-vs-input="`field-${field.name}`"
                                type="checkbox"
                                v-model="field.value"
                                :name="field.name"
                                :disabled="
                                  (!disabledInfoPersonal &&
                                    employeeState !== 2) ||
                                  hasIntengrationSichernPeople
                                "
                                @click="disabledInfoPersonal = true"
                                @change="handlerCBU(field)"
                                :label="field.alias"
                              />
                              <p class="inf-p">{{ field.alias }}</p>
                              <span></span>
                            </label>
                          </div>
                          <div class="mb-3" v-if="field.name === 'calle'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo('calle', 'calleTexting', field)
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo('calle', 'calleTexting', field)
                              "
                              class="input_styles"
                              type="text"
                              id="calle"
                              name="calle"
                              v-model="field.value"
                              :required="calleTexting"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('calle')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="mb-3" v-if="field.name === 'direccion'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  'direccion',
                                  'direccionTexting',
                                  field
                                )
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo(
                                  'direccion',
                                  'direccionTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              id="direccion"
                              name="direccion"
                              v-model="field.value"
                              :required="direccionTexting"
                              maxlength="400"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('calle')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="mb-3" v-if="field.name === 'numero'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  'numero',
                                  'numeroTexting',
                                  field
                                )
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo(
                                  'numero',
                                  'numeroTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              id="numero"
                              name="numero"
                              v-model="field.value"
                              :required="numeroTexting"
                              maxlength="15"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('numero')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="mb-3"
                            v-if="field.name === 'codigopostal'"
                          >
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  'codigopostal',
                                  'codigoPostalTexting',
                                  field
                                )
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo(
                                  'codigopostal',
                                  'codigoPostalTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              id="codigopostal"
                              name="codigopostal"
                              v-model="field.value"
                              :required="codigoPostalTexting"
                              maxlength="15"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('codigopostal')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div v-if="field.name === 'ciudad'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  'ciudad',
                                  'ciudadTexting',
                                  field
                                )
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo(
                                  'ciudad',
                                  'ciudadTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              id="ciudad"
                              name="ciudad"
                              v-model="field.value"
                              :required="ciudadTexting"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('ciudad')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div v-if="field.name === 'address_level_bottom'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  field.name,
                                  'addressLevelBottomTexting',
                                  field
                                )
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo(
                                  field.name,
                                  'addressLevelBottomTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              :id="field.name"
                              :name="field.name"
                              v-model="field.value"
                              :required="addressLevelBottomTexting"
                              maxlength="150"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('address_level_middle')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div v-if="field.name === 'address_level_middle'">
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  field.name,
                                  'addressLevelMiddleTexting',
                                  field
                                )
                              "
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              @keyup="
                                handleChangeInfo(
                                  field.name,
                                  'addressLevelMiddleTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              :id="field.name"
                              :name="field.name"
                              v-model="field.value"
                              :required="addressLevelMiddleTexting"
                              maxlength="200"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('address_level_middle')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div
                            v-if="
                              field.type === 'combo' &&
                              field.name === 'address_level_top'
                            "
                            class="pb-4"
                          >
                            <Multiselect
                              :data-vs-input="`field-${field.name}`"
                              :disabled="
                                employeeState !== 2 ||
                                hasIntengrationSichernPeople
                              "
                              :options="field.combo_values"
                              :value="field.value"
                              @input="
                                handleChangeComboLevelAddress($event, field)
                              "
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              maxlength="200"
                            />
                          </div>
                          <div
                            v-if="
                              field.type === 'string' &&
                              field.name === 'address_level_top'
                            "
                          >
                            <input
                              :data-vs-input="`field-${field.name}`"
                              @keyup.delete="
                                handleChangeInfo(
                                  field.name,
                                  'addressLevelTopTexting',
                                  field
                                )
                              "
                              :disabled="employeeState !== 2"
                              @keyup="
                                handleChangeInfo(
                                  field.name,
                                  'addressLevelTopTexting',
                                  field
                                )
                              "
                              class="input_styles"
                              type="text"
                              :id="field.name"
                              :name="field.name"
                              v-model="field.value"
                              :required="addressLevelTopTexting"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias }}
                            </label>
                            <div
                              class="m--font-danger"
                              v-show="errors.has('address_level_top')"
                            >
                              <p class="error-style">
                                {{
                                  $t('message.login_first_login_required_field')
                                }}
                              </p>
                            </div>
                          </div>
                          <div v-if="vpHasCountry(field)" class="pb-4">
                            <label class="typo__label">{{
                              countryVPSelected ? field.alias : ''
                            }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              v-model="countryVPSelected"
                              @input="handleChangeCountryVP(field)"
                              :disabled="employeeState !== 2"
                              :options="countriesVP"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="description"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpHasProvince(field)" class="pb-4">
                            <label class="typo__label">{{
                              provinceVPSelected ? field.alias : ''
                            }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              v-model="provinceVPSelected"
                              @input="handleChangeProvincesVP(field)"
                              :disabled="
                                employeeState !== 2 ||
                                !countryVPSelected ||
                                provinceDisabled
                              "
                              :options="provincesVP"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="description"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpCountiesConfig(field)" class="pb-4">
                            <label class="typo__label">{{ field.alias }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              @input="handleChangeCountiesVP(field)"
                              v-model="vpConfigState.domicilio_counties"
                              :disabled="
                                employeeState !== 2 ||
                                (provinceVPSelected &&
                                  !provinceVPSelected.id) ||
                                countiesDisabled ||
                                !provinceVPSelected
                              "
                              :options="dataVp.domicilio_counties"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="description"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpDistritoConfig(field)" class="pb-4">
                            <label class="typo__label">{{ field.alias }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              @input="handleChangeDistritoVP(field)"
                              v-model="vpConfigState.domicilio_distrito"
                              :disabled="
                                employeeState !== 2 ||
                                (provinceVPSelected &&
                                  !provinceVPSelected.id) ||
                                cityDisabled ||
                                !provinceVPSelected ||
                                (vpConfigState.domicilio_counties &&
                                  !vpConfigState.domicilio_counties.id)
                              "
                              :options="citiesVP"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="description"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpViaConfig(field)" class="pb-4">
                            <label class="typo__label">{{ field.alias }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              @input="handleChangeViaVP(field)"
                              v-model="vpConfigState.domicilio_via"
                              :disabled="employeeState !== 2"
                              :options="dataVp.domicilio_via"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="description"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpZonaConfig(field)" class="pb-4">
                            <label class="typo__label">{{ field.alias }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              @input="handleChangeZonaVP(field)"
                              v-model="vpConfigState.domicilio_zona"
                              :disabled="employeeState !== 2"
                              :options="dataVp.domicilio_zona"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="description"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpHasCity(field)" class="pb-4">
                            <label class="typo__label">{{
                              cityVPSelected ? field.alias : ''
                            }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              v-model="cityVPSelected"
                              @input="handleChangeCitiesVP(field)"
                              :disabled="
                                employeeState !== 2 ||
                                (provinceVPSelected &&
                                  !provinceVPSelected.id) ||
                                cityDisabled ||
                                !provinceVPSelected
                              "
                              :options="citiesVP"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="description"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpHasMaritalStatus(field)" class="pb-4">
                            <label class="typo__label">{{
                              maritalStatusVPSelected ? field.alias : ''
                            }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              v-model="maritalStatusVPSelected"
                              @input="handleChangeMaritalStatusVP(field)"
                              :disabled="
                                employeeState !== 2 || maritalStatusDisabled
                              "
                              :options="maritalStatusVP"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="id"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpHasAddressType(field)" class="pb-4">
                            <label class="typo__label">{{
                              addressTypeVPSelected ? field.alias : ''
                            }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              v-model="addressTypeVPSelected"
                              @input="handleChangeAddressTypeVP(field)"
                              :disabled="
                                employeeState !== 2 || addressTypeDisabled
                              "
                              :options="addressTypesVP"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="id"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div v-if="vpHasNationality(field)" class="pb-4">
                            <label class="typo__label">{{
                              nationalityVPSelected ? field.alias : ''
                            }}</label>
                            <Multiselect
                              :data-vs-multiselect="`field-${field.name}`"
                              v-model="nationalityVPSelected"
                              @input="handleChangeNationalityVP(field)"
                              :disabled="
                                employeeState !== 2 || nationalityDisabled
                              "
                              :options="nationalitiesVP"
                              :searchable="false"
                              :show-labels="false"
                              :placeholder="field.alias"
                              track-by="id"
                              label="description"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.description }}</template
                              >
                            </Multiselect>
                          </div>
                          <div
                            v-if="inputSichernPeopleIntegration(field.name)"
                            class="pb-4"
                          >
                            <input
                              :data-vs-input="`field-${field.name}`"
                              class="input_styles"
                              type="text"
                              :id="field.name"
                              :name="field.name"
                              v-model="field.value"
                              :disabled="hasIntengrationSichernPeople"
                              required
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias | capitalize }}
                            </label>
                          </div>
                          <div
                            v-if="
                              field.type === 'date' &&
                              field.name ===
                                'section_personales_fecha_nacimiento'
                            "
                            class="pb-4"
                          >
                            <input
                              :data-vs-input="`field-${field.name}`"
                              :formatter="format"
                              type="date"
                              class="input_styles"
                              v-model="field.value"
                              :disabled="hasIntengrationSichernPeople"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="label_styles">
                              {{ field.alias | capitalize }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div id="documentosPersonalesLink"></div>
      <div>
        <div ref="alert"></div>
        <ul class="m-nav">
          <div
            v-for="section in filterSection('documentos')"
            class="mt-4"
            :key="section.id"
          >
            <div v-for="level in section.levels" :key="level.id">
              <div v-for="field in level.fields" :key="field.id">
                <div class="mb-4 m-portlet card-style">
                  <div class="m-portlet__head h-100">
                    <div
                      class="title_edit_container h-auto mb-0 mt-0"
                      id="informacionPersonalLink"
                    >
                      <div class="subtitle_useram">{{ field.alias }}</div>
                    </div>
                    <div class="m-portlet__head-tools">
                      <div>
                        <div v-if="field.mandatory === false">
                          <div
                            class="d-flex align-items-center"
                            v-if="field.value === true"
                          >
                            <div class="m-porlet-info-notApply">
                              <label>{{ $t('message.ei_apply') }} </label>
                            </div>
                            <div class="bg-red mr-4" style="width: 30px"></div>
                          </div>
                          <div v-else>
                            <div
                              v-if="validateDoc(field, 'documento')"
                              class="d-flex align-items-center"
                            >
                              <div :id="field.name + 'toPill'" class="d-none">
                                <div class="d-flex align-items-center">
                                  <div class="m-portlet__head-caption">
                                    <button
                                      :data-vs-button="`field-cancel-${field.name}`"
                                      @click="buttonsDocuments(field, 'toPill')"
                                      @click.prevent="disabledPersonal"
                                      class="btn btn-secondary mr-4"
                                    >
                                      {{ $t('message.ob_submit_swal_reject') }}
                                    </button>
                                    <button
                                      :data-vs-button="`field-${field.name}`"
                                      v-if="!isLoading"
                                      @click.prevent="
                                        handleButtonInfoPersonal(true, field)
                                      "
                                      type="submit"
                                      class="btn btn-primary ml-0 mr-0"
                                    >
                                      {{
                                        $t(
                                          'message.ei_personal_info_save_changes'
                                        )
                                      }}
                                    </button>
                                    <button
                                      :data-vs-button="`field-${field.name}`"
                                      v-if="isLoading"
                                      class="btn btn-primary ml-0 mr-0"
                                    >
                                      <div
                                        class="m-loader m-loader--light"
                                      ></div>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                :id="field.name + 'toSave'"
                                class="bg-success border-success m-porlet-info-complete ml-3"
                              >
                                <label>{{ $t('message.ei_complete') }} </label>
                              </div>
                              <h2
                                :data-vs-button="`field-down-${field.name}`"
                                :id="field.name + 'down'"
                                @click="groupDocuments(field.name, 'down')"
                                class="icon-Down c-pointer"
                                style="font-size: 30px"
                              ></h2>
                              <h2
                                :data-vs-button="`field-up-${field.name}`"
                                :id="field.name + 'up'"
                                @click="groupDocuments(field.name, 'up')"
                                class="icon-Up c-pointer d-none"
                                style="font-size: 30px"
                              ></h2>
                            </div>
                            <div v-else class="d-flex align-items-center">
                              <div :id="field.name + 'toPill'" class="d-none">
                                <div class="d-flex align-items-center">
                                  <div class="m-portlet__head-caption">
                                    <button
                                      :data-vs-button="`field-cancel-${field.name}`"
                                      @click="buttonsDocuments(field, 'toPill')"
                                      @click.prevent="disabledPersonal"
                                      class="btn btn-secondary mr-4"
                                    >
                                      {{ $t('message.ob_submit_swal_reject') }}
                                    </button>
                                    <button
                                      :data-vs-button="`field-${field.name}`"
                                      v-if="!isLoading"
                                      @click.prevent="
                                        handleButtonInfoPersonal(true, field)
                                      "
                                      type="submit"
                                      class="btn btn-primary ml-0 mr-0"
                                    >
                                      {{
                                        $t(
                                          'message.ei_personal_info_save_changes'
                                        )
                                      }}
                                    </button>
                                    <button
                                      :data-vs-button="`field-${field.name}`"
                                      v-if="isLoading"
                                      class="btn btn-primary ml-0 mr-0"
                                    >
                                      <div
                                        class="m-loader m-loader--light"
                                      ></div>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                :id="field.name + 'toSave'"
                                class="m-porlet-info-ncomplete ml-3"
                              >
                                <label>{{
                                  $t('message.ei_OnboardingIncomplete')
                                }}</label>
                              </div>
                              <h2
                                :data-vs-button="`incomplete-down-${field.id}`"
                                :id="field.name + 'down'"
                                @click="groupDocuments(field.name, 'down')"
                                class="icon-Down c-pointer"
                                style="font-size: 30px"
                              ></h2>
                              <h2
                                :data-vs-button="`incomplete-up-${field.id}`"
                                :id="field.name + 'up'"
                                @click="groupDocuments(field.name, 'up')"
                                class="icon-Up c-pointer d-none"
                                style="font-size: 30px"
                              ></h2>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div
                            v-if="validateDoc(field, 'documento')"
                            class="d-flex align-items-center"
                          >
                            <div :id="field.name + 'toPill'" class="d-none">
                              <div class="d-flex align-items-center">
                                <div class="m-portlet__head-caption">
                                  <button
                                    :data-vs-button="`field-cancel-${field.name}`"
                                    @click="buttonsDocuments(field, 'toPill')"
                                    @click.prevent="disabledPersonal"
                                    class="btn btn-secondary mr-4"
                                  >
                                    {{ $t('message.ob_submit_swal_reject') }}
                                  </button>
                                  <button
                                    :data-vs-button="`field-${field.name}`"
                                    v-if="!isLoading"
                                    @click.prevent="
                                      handleButtonInfoPersonal(true, field)
                                    "
                                    type="submit"
                                    class="btn btn-primary ml-0 mr-0"
                                  >
                                    {{
                                      $t(
                                        'message.ei_personal_info_save_changes'
                                      )
                                    }}
                                  </button>
                                  <button
                                    :data-vs-button="`field-${field.name}`"
                                    v-if="isLoading"
                                    class="btn btn-primary ml-0 mr-0"
                                  >
                                    <div class="m-loader m-loader--light"></div>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div
                              :id="field.name + 'toSave'"
                              class="bg-success border-success m-porlet-info-complete ml-3"
                            >
                              <label>{{ $t('message.ei_complete') }} </label>
                            </div>
                            <h2
                              :id="field.name + 'down'"
                              :data-vs-button="`doc-group-down-${field.id}`"
                              @click="groupDocuments(field.name, 'down')"
                              class="icon-Down c-pointer"
                              style="font-size: 30px"
                            ></h2>
                            <h2
                              :id="field.name + 'up'"
                              @click="groupDocuments(field.name, 'up')"
                              class="icon-Up c-pointer d-none"
                              style="font-size: 30px"
                            ></h2>
                          </div>
                          <div v-else class="d-flex align-items-center">
                            <div :id="field.name + 'toPill'" class="d-none">
                              <div class="d-flex align-items-center">
                                <div class="m-portlet__head-caption">
                                  <button
                                    :data-vs-button="`field-cancel-${field.name}`"
                                    @click="buttonsDocuments(field, 'toPill')"
                                    @click.prevent="disabledPersonal"
                                    class="btn btn-secondary mr-4"
                                  >
                                    {{ $t('message.ob_submit_swal_reject') }}
                                  </button>
                                  <button
                                    :data-vs-button="`field-${field.name}`"
                                    v-if="!isLoading"
                                    @click.prevent="
                                      handleButtonInfoPersonal(true, field)
                                    "
                                    type="submit"
                                    class="btn btn-primary ml-0 mr-0"
                                  >
                                    {{
                                      $t(
                                        'message.ei_personal_info_save_changes'
                                      )
                                    }}
                                  </button>
                                  <button
                                    :data-vs-button="`field-${field.name}`"
                                    v-if="isLoading"
                                    class="btn btn-primary ml-0 mr-0"
                                  >
                                    <div class="m-loader m-loader--light"></div>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div
                              :id="field.name + 'toSave'"
                              class="m-porlet-info-ncomplete ml-3"
                            >
                              <label>{{
                                $t('message.ei_OnboardingIncomplete')
                              }}</label>
                            </div>
                            <h2
                              :data-vs-button="`field-down-${field.name}`"
                              :id="field.name + 'down'"
                              @click="groupDocuments(field.name, 'down')"
                              class="icon-Down c-pointer"
                              style="font-size: 30px"
                            ></h2>
                            <h2
                              :data-vs-button="`field-up-${field.name}`"
                              :id="field.name + 'up'"
                              @click="groupDocuments(field.name, 'up')"
                              class="icon-Up c-pointer d-none"
                              style="font-size: 30px"
                            ></h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="field.value === false || field.value === null"
                    class="m-portlet__body show_img d-none"
                    :id="field.name"
                  >
                    <div class="row">
                      <div
                        v-for="itemImg in isImage(field, 'img')"
                        :key="itemImg.id"
                        class="col-lg-6"
                      >
                        <ImgLoad
                          :employeeState="employeeState"
                          :img_value="itemImg.value"
                          :img_name="itemImg.name"
                          :img_type="section.name"
                        ></ImgLoad>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        v-for="item in isImage(field, 'notImg')"
                        :key="item.id"
                        class="col-lg-6"
                      >
                        <span v-if="item.type != 'Image'" class="label-infp">{{
                          item.alias
                        }}</span>
                        <input
                          :data-vs-input="`field-${field.name}`"
                          v-if="item.type === 'string'"
                          type="text"
                          @keyup.delete="handleChange(item, 'toSave', field)"
                          @keyup="handleChange(item, 'toSave', field)"
                          @change="handleChange(item, 'toSave', field)"
                          class="form-control form-control-pi m-input"
                          v-model="item.value"
                          disabled
                        />
                        <input
                          :data-vs-input="`field-${field.name}`"
                          v-if="item.type === 'number'"
                          type="text"
                          @keyup.delete="handleChange(item, 'toSave', field)"
                          @keyup="handleChange(item, 'toSave', field)"
                          @change="handleChange(item, 'toSave', field)"
                          class="form-control form-control-pi m-input"
                          v-model="item.value"
                          disabled
                        />
                        <input
                          :data-vs-input="`field-${field.name}`"
                          v-if="item.type === 'date'"
                          :formatter="format"
                          type="date"
                          @keyup.delete="handleChange(item, 'toSave', field)"
                          @keyup="handleChange(item, 'toSave', field)"
                          @change="handleChange(item, 'toSave', field)"
                          class="form-control form-control-pi m-input"
                          v-model="item.value"
                          disabled
                        />
                        <select
                          :data-vs-select="`field-${field.name}`"
                          v-if="item.type === 'combo'"
                          @change="handleChange(item, 'toSave', field)"
                          class="form-control form-control-pi m-input"
                          v-model="item.value"
                          disabled
                        >
                          <option :value="0">
                            {{ $t('message.form_select') }}
                          </option>
                          <option
                            v-for="option in item.combo_values"
                            :value="option"
                            :key="option.id"
                            :data-vs-option-value="`field-${option.id}`"
                          >
                            {{ option }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <div class="m-portlet m-portlet--tab" v-if="totalParientesLength > 0">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class="la la-gear"></i>
              </span>
              <h3 class="m-portlet__head-text m-portlet__head-text_fixed">
                {{ $t('message.ei_familiares_title') }}
              </h3>
            </div>
          </div>
          <div v-show="!disabledInfoPersonal && !isEditingDoc">
            <div
              v-if="buttonOptionParentSection && employeeState !== 2"
              class="personal_info_edit_button m-portlet__head-caption"
            >
              <span
                @click="disabledParentSection = (disabledParentSection + 1) % 2"
                @click.prevent="handleButtonParentSection"
                class="personal_info_edit_button m-portlet__head-caption"
                data-vs-button="parent-section"
              >
                {{ $t('message.ei_personal_info_edit') }}
                <span
                  class="m-portlet__head-caption icon-EditCircle icon-Edit-1-size"
                >
                </span>
              </span>
            </div>
            <div v-else class="m-portlet__head-caption" style="height: 1.5em">
              <button
                @click.prevent="disabledParent"
                :disabled="employeeState !== 2"
                @click.exact="
                  disabledParentSection = (disabledParentSection + 1) % 2
                "
                class="btn button_cancel_changes"
                data-vs-button="disable-parent-section"
              >
                {{ $t('message.ob_submit_swal_reject') }}
              </button>
              <button
                @click.prevent="handleButtonParentSection"
                :disabled="employeeState !== 2"
                @click.exact="
                  disabledParentSection = (disabledParentSection + 1) % 2
                "
                type="submit"
                class="btn button_save_changes"
                data-vs-button="parent-change-section"
              >
                {{ $t('message.ei_personal_info_save_changes') }}
              </button>
            </div>
          </div>
        </div>
        <div class="m-portlet__body sub_portlets">
          <ul class="m-nav m-nav--hover-bg m-portlet-fit--sides">
            <li class="m-nav__item">
              <div class="form-group m-form__group">
                <div
                  v-for="section in filterSection('family')"
                  class="m-portlet__body"
                  :key="section.id"
                >
                  <div class="m-form m-form--fit m-form--label-align-right">
                    <div class="m-nav m-nav--hover-bg m-portlet-fit--sides">
                      <div v-for="level in section.levels" :key="level.id">
                        <div
                          v-for="field in level.fields"
                          class="col-xl-12 col-lg-12 inter-porlets"
                          :key="field.id"
                        >
                          <div
                            v-for="(item, index) in totalParientes"
                            :key="item.id"
                            class="m-portlet card-style m-portlet--mobile m-portlet--body-progress-"
                            style="border-radius: 5px"
                          >
                            <div
                              class="m-portlet__head"
                              style="background: rgba(0, 0, 0, 0.12)"
                            >
                              <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                  <h3 class="m-portlet__head-text" v-once>
                                    {{
                                      childrenIndex(
                                        item['pariente_parentesco_' + index]
                                      )
                                    }}
                                  </h3>
                                </div>
                              </div>
                              <div class="m-portlet__head-tools">
                                <div
                                  v-if="validateFamily(item, 'pariente', index)"
                                  class="m-porlet-info-complete"
                                >
                                  <label>{{ $t('message.ei_complete') }}</label>
                                </div>
                                <div v-else class="m-porlet-info-ncomplete">
                                  <label>{{
                                    $t('message.ei_OnboardingIncomplete')
                                  }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="m-portlet__body">
                              <div class="row parientes">
                                <template v-for="itemkey in field.subfields">
                                  <div
                                    v-if="itemkey.type == 'Image'"
                                    class="col-lg-6"
                                    :key="itemkey.id"
                                  >
                                    <ImgLoad
                                      :img_name="itemkey.name + '_' + index"
                                      :img_value="
                                        item[itemkey.name + '_' + index]
                                      "
                                      :img_type="field.alias"
                                      :img_index="index"
                                    ></ImgLoad>
                                  </div>
                                </template>
                                <div class="col-lg-6">
                                  <div
                                    v-for="itemkey in field.subfields"
                                    :key="itemkey.id"
                                  >
                                    <div v-if="itemkey.type != 'Image'">
                                      <span
                                        v-if="itemkey.type != 'Image'"
                                        class="label-infp"
                                        >{{ itemkey.alias }}</span
                                      >
                                      <input
                                        v-if="
                                          itemkey.type === 'string' &&
                                          itemkey.name != 'pariente_parentesco'
                                        "
                                        type="text"
                                        class="form-control form-control-pi m-input"
                                        @change="
                                          handleChangeFami(
                                            itemkey.name + '_' + index,
                                            item[itemkey.name + '_' + index]
                                          )
                                        "
                                        v-model="
                                          item[itemkey.name + '_' + index]
                                        "
                                        :disabled="
                                          [
                                            disabledParentSection === 1
                                              ? false
                                              : true
                                          ] && employeeState !== 2
                                        "
                                        :data-vs-input="`input-${itemkey.name}`"
                                      />
                                      <input
                                        v-if="
                                          itemkey.type === 'string' &&
                                          itemkey.name == 'pariente_parentesco'
                                        "
                                        type="text"
                                        class="form-control form-control-pi m-input"
                                        v-model="
                                          item[itemkey.name + '_' + index]
                                        "
                                        disabled
                                        :data-vs-input="`input-${itemkey.name}`"
                                      />
                                      <input
                                        v-if="itemkey.type === 'number'"
                                        type="text"
                                        style="height: 200px"
                                        class="form-control form-control-pi m-input"
                                        @change="
                                          handleChangeFami(
                                            itemkey.name + '_' + index,
                                            item[itemkey.name + '_' + index]
                                          )
                                        "
                                        v-model="
                                          item[itemkey.name + '_' + index]
                                        "
                                        :disabled="
                                          [
                                            disabledParentSection === 1
                                              ? false
                                              : true
                                          ] && employeeState !== 2
                                        "
                                        :data-vs-input="`input-${itemkey.name}`"
                                      />
                                      <input
                                        v-if="itemkey.type === 'date'"
                                        type="date"
                                        class="form-control form-control-pi m-input"
                                        @change="
                                          handleChangeFami(
                                            itemkey.name + '_' + index,
                                            item[itemkey.name + '_' + index]
                                          )
                                        "
                                        v-model="
                                          item[itemkey.name + '_' + index]
                                        "
                                        :disabled="
                                          [
                                            disabledParentSection === 1
                                              ? false
                                              : true
                                          ] && employeeState !== 2
                                        "
                                        :data-vs-input="`input-${itemkey.name}`"
                                      />
                                      <select
                                        v-if="itemkey.type === 'combo'"
                                        class="form-control form-control-pi m-input"
                                        @change="
                                          handleChangeFami(
                                            itemkey.name + '_' + index,
                                            item[itemkey.name + '_' + index]
                                          )
                                        "
                                        :disabled="
                                          [
                                            disabledParentSection === 1
                                              ? false
                                              : true
                                          ] && employeeState !== 2
                                        "
                                        :data-vs-input="`input-${itemkey.name}`"
                                      >
                                        <option
                                          :value="0"
                                          :data-vs-input="`default-${itemkey.name}`"
                                        >
                                          {{ $t('message.form_select') }}
                                        </option>
                                        <option
                                          v-for="option in itemkey.combo_values"
                                          :value="option"
                                          :key="option.id"
                                          :data-vs-option-value="`input-${itemkey.name}`"
                                        >
                                          {{ option }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div
        id="documentosLink"
        class="m-portlet card-style m-portlet--tab"
        v-if="eform.length > 0"
      >
        <div class="h-100 m-portlet__head">
          <div
            class="title_edit_container h-auto mb-0 mt-0"
            id="informacionPersonalLink"
          >
            <div class="subtitle_useram">
              {{ $t('message.ei_personal_formDigital_title') }}
            </div>
          </div>
          <hr />
        </div>
        <div v-for="section in filterSection('eforms')" :key="section.id">
          <div v-for="item in eform" :key="item.id">
            <div
              class="m-portlet__head"
              :class="
                item.firmado == 'NO FIRMADO' ? 'incompleted' : 'completed'
              "
            >
              <div class="m-portlet__head-caption w-auto">
                <div class="m-portlet__head-title">
                  <h3 class="m-portlet__head-text">
                    {{ item.nombre | capitalize }}
                  </h3>
                </div>
              </div>
              <div class="hover_img">
                <div
                  v-if="item.firmado == 'NO FIRMADO'"
                  class="m-porlet-info-ncomplete"
                >
                  <label>{{ $t('message.ei_OnboardingIncomplete') }}</label>
                </div>
                <div
                  v-else
                  class="bg-success border-success m-porlet-info-complete"
                >
                  <label>{{ $t('message.ei_OnboardingComplete') }}</label>
                </div>
                <div
                  v-if="employeeState != 3"
                  class="icon-Download"
                  title="Descargar Documento"
                  @click="DocumentPdf(appId, item.id, 'pdf', 'all')"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Zoom :imgValue="imgToShowModal" :fileExtension="fileExtension"></Zoom>
  </div>
</template>
<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import Employee from '../../../apiClient/Employee'
import SichernIntegration from '../../../apiClient/SichernIntegration'
import swal from 'sweetalert2'
import Search from '../../../apiClient/Search'
import Eforms from '../../../apiClient/Eforms'
import Users from '../../../apiClient/User'
import Onboarding from '../../../apiClient/OnBoarding'
import _ from 'underscore'
import Alert from '@/components/generics/Alert.vue'
import ImgLoad from '@/components/generics/ImgLoad.vue'
import Statistics from '@/components/Statistics.vue'
import VueElementLoading from 'vue-element-loading'
import PieChart from 'vue-pie-chart/src/PieChart.vue'
import Zoom from '@/components/generics/Zoom.vue'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import Multiselect from 'vue-multiselect'

export default {
  data() {
    return {
      obstats: {
        personalData: {
          items_obligatorios_completos: 0,
          items_obligatorios_totales: 0
        },
        documentData: {
          items_obligatorios_completos: 0,
          items_obligatorios_totales: 0
        },
        eformData: {
          items_obligatorios_completos: 0,
          items_obligatorios_totales: 0
        }
      },
      es: es,
      infoPersonal: [],
      config: [],
      templates: [],
      imgAvatar: '',
      message: '',
      totalParientes: 0,
      totalParientesLength: 0,
      buttonOptionInfoPersonal: true,
      disabledInfoPersonal: false,
      buttonOptionPersonalDocs: true,
      requestAPILoading: false,
      disabledPersonalDocs: 0,
      buttonOptionParentSection: true,
      disabledParentSection: 0,
      fieldsInChange: [],
      tmp: [],
      qrySearchInit: '',
      eform: [],
      locationOrigin: location.origin,
      showCbu: false,
      showLoadingVueComponent: false,
      counter: 0,
      appId: '',
      bus: new Vue(),
      itemsObligatoriosTotales: 0,
      itemsObligatoriosCompletos: 0,
      isEditingDoc: false,
      isEditingParent: false,
      imgToShowModal: '',
      disabledInfoPersonalOnboarding: false,
      state: 0,
      nombreTexting: true,
      dniTexting: true,
      apellidoTexting: true,
      cuilTexting: true,
      mailTexting: true,
      legajoTexting: true,
      celularTexting: true,
      cbuTexting: true,
      emergenciaTexting: true,
      calleTexting: true,
      numeroTexting: true,
      codigoPostalTexting: true,
      addressLevelMiddleTexting: true,
      ciudadTexting: true,
      addressLevelBottomTexting: true,
      direccionTexting: true,
      addressLevelTopTexting: true,
      documentStatus: false,
      familyStatus: false,
      isLoading: false,
      hasChanged: '',
      hasIntengrationSichernPeople: false,
      countriesVP: [],
      countryVPSelected: null,
      provincesVP: [],
      provinceVPSelected: null,
      provinceDisabled: false,
      countiesDisabled: false,
      citiesVP: [],
      cityVPSelected: null,
      cityDisabled: false,
      maritalStatusVP: [],
      maritalStatusVPSelected: null,
      maritalStatusDisabled: false,
      addressTypesVP: [],
      addressTypeVPSelected: null,
      addressTypeDisabled: false,
      nationalitiesVP: [],
      nationalityVPSelected: null,
      nationalityDisabled: false,
      vpConfigState: {
        domicilio_zona: '',
        domicilio_via: '',
        domicilio_counties: '',
        domicilio_distrito: ''
      },
      dataVp: {
        domicilio_zona: '',
        domicilio_via: '',
        domicilio_counties: '',
        domicilio_distrito: ''
      },
      fileExtension: ''
    }
  },
  props: {
    employeeState: 0,
    resetData: Boolean,
    setTemplateChanged: Function
  },
  components: {
    Alert,
    ImgLoad,
    Statistics,
    VueElementLoading,
    'pie-chart': PieChart,
    Zoom,
    Datepicker,
    Multiselect
  },
  updated: function () {
    this.$nextTick(function () {
      this.beginDocuments()
    })
  },
  created() {
    this.ob = new Employee()
    this.ap = new Search()
    this.ef = new Eforms()
    this.op = new Onboarding()
    this.vi = new SichernIntegration()
    this.usersProfile = new Users()
    this.$store.dispatch('setInitialOnBoardingList')
    this.getEmployeeById()
    this.getUserInformation(this.$route.params.id)
    this.getInfoUser()
    this.$root.$on('image_deleted_document', (idIMG) => {
      _.each(this.config.sections[1].levels[0].fields, (field, w) => {
        _.each(field.subfields, (l, e) => {
          if (l.name == idIMG) {
            l.value = ''
          }
        })
      })
    })
    this.$root.$on('image_deleted_family', (idIMG, indexIMG) => {
      this.config.sections[2].levels[0].values[indexIMG][idIMG] = ''
    })
    this.$root.$on('emit_zoom', (value) => {
      this.imgToShowModal = value.img_value
      this.fileExtension = value.extension
    })
    this.searchStatistics(this.$route.params.id)
    this.checkActiveSichernPeopleIntegration()
    this.getCountries()
    this.getMaritalStatus()
    this.getAddressTypes()
    this.getNationalities()
    if (this.$store.state.user.pais === 'PE') {
      this.getVia()
      this.getZona()
    }
  },

  methods: {
    format(value, event) {
      return moment(value).format('DD/MM/YYYY')
    },
    getUserInformation(id) {
      this.usersProfile
        .getinfoEmployee(id)
        .then((res) => {
          if (res.status === 200) {
            let response = res.data
            if (response.estado_empresa == 1) this.state = 1
            if (response.estado_empresa == 2) this.state = 2
          }
        })
        .catch((error) => {})
    },
    getInfoUser() {
      this.$store
        .dispatch('getProfile')
        .then((res) => {
          this.appId = res.aplicacion.id
        })
        .catch((error) => {})
    },
    checkActiveSichernPeopleIntegration() {
      const type = 'VP_ONBOARDING'
      this.vi
        .checkIntegrationSichernPeopleByType(type)
        .then((res) => {
          this.hasIntengrationSichernPeople = res.data.data.enabled
        })
        .catch((error) => {})
    },
    cancelEditInformation(event) {
      this.errors.clear()
      switch (event) {
        case 'disabledInfoPersonalOnboarding':
          {
            document.getElementById('formInfoOnboarding').reset()
            this.formInfoOnboarding = {
              name_emergency: '',
              number_emergency: null,
              street: '',
              number_street: null,
              city: '',
              state: '',
              cbu: '',
              bank: '',
              number_bank: null,
              spounse: '',
              number_children: null
            }
            this.disabledInfoPersonalOnboarding = false
          }
          break
      }
    },
    editInformation(event) {
      switch (event) {
        case 'disabledInfoPersonalOnboarding':
          this.disabledInfoPersonalOnboarding = true
          break
      }
    },
    getEmployeeById() {
      this.ob
        .getEmployeeById(this.$route.params.id)
        .then((result) => {
          if (result.status === 200) {
            this.infoPersonal = result.data
            this.$store.dispatch('setEstadoEmpresa', {
              estadoEmpresa: this.infoPersonal[0].estado_empresa
            })

            this.config = result.data[0].template
            this.buildSearch()
          }
        })
        .catch((error) => {})
    },
    filterSection(section) {
      if (this.config.sections) {
        if (section === 'family') {
          let section = this.config.sections.filter(
            (section) => section.name === 'seccion_parientes'
          )
          return section
        } else if (section === 'documentos') {
          let section = this.config.sections.filter(
            (section) => section.name === 'section_documentos'
          )
          return section
        } else if (section === 'eforms') {
          let section = this.config.sections.filter(
            (section) => section.name === 'seccion_eforms'
          )
          return section
        } else if (section === 'RRHH') {
          return (section = this.config.sections.filter(
            (section) =>
              section.name !== 'section_documentos' &&
              section.name !== 'seccion_eforms' &&
              section.name !== 'seccion_parientes'
          ))
        }
      }
    },
    handleButtonInfoPersonal(doc, field) {
      if (!doc) this.disabledInfoPersonal = true
      this.isLoading = true
      this.handlerChangeSubmit(field)
    },
    disabledPersonal() {
      this.disabledInfoPersonal = false
      this.getEmployeeById()
    },
    handleButtonPersonalDocs() {
      if (this.buttonOptionPersonalDocs) {
        this.handlerChangeSubmit()
      }
    },
    disabledPersonalDoc() {
      this.isEditingDoc = false
      this.getEmployeeById()
      this.buttonOptionPersonalDocs = !this.buttonOptionPersonalDocs
    },
    handleButtonParentSection() {
      this.isEditingParent = true
      this.buttonOptionParentSection = !this.buttonOptionParentSection

      if (this.buttonOptionParentSection) {
        this.handlerChangeSubmit(e)
      }
    },
    disabledParent() {
      this.isEditingParent = false
      this.getEmployeeById()
      this.buttonOptionParentSection = !this.buttonOptionParentSection
    },
    handleChange(event, value, field) {
      if (this.employeeState != 3) {
        if (value == 'toPill' || value == 'toSave') {
          this.buttonsDocuments(field, value)
        }
        if (event.name) {
          let fieldChanged =
            '{"name":"' + event.name + '","value":"' + event.value + '"}'
          this.fieldsInChange.push(fieldChanged)
        }
      }
    },
    handleChangeComboLevelAddress(event, field) {
      field.value = event
      this.disabledInfoPersonal = true
      if (field.name) {
        let fieldChanged =
          '{"name":"' + field.name + '","value":"' + field.value + '"}'
        let auxFieldChanged = JSON.parse(fieldChanged)
        this.fieldsInChange.forEach((element, index) => {
          let auxElement = JSON.parse(element)
          if (auxElement.name == auxFieldChanged.name) {
            this.fieldsInChange.splice(index, 1)
          }
        })
        this.fieldsInChange.push(fieldChanged)
      }
    },
    handleChangeInfo(event, type, field) {
      this.disabledInfoPersonal = true
      if (document.getElementById(event).value != '') {
        switch (type) {
          case 'nombreTexting':
            this.nombreTexting = true
            break
          case 'apellidoTexting':
            this.apellidoTexting = true
            break
          case 'cuilTexting':
            this.cuilTexting = true
            break
          case 'dniTexting':
            this.dniTexting = true
            break
          case 'legajoTexting':
            this.legajoTexting = true
            break
          case 'mailTexting':
            this.mailTexting = true
            break
          case 'celularTexting':
            this.celularTexting = true
            break
          case 'emergenciaTexting':
            this.emergenciaTexting = true
            break
          case 'cbuTexting':
            this.cbuTexting = true
            break
          case 'calleTexting':
            this.calleTexting = true
            break
          case 'direccionTexting':
            this.direccionTexting = true
            break
          case 'numeroTexting':
            this.numeroTexting = true
            break
          case 'codigoPostalTexting':
            this.codigoPostalTexting = true
            break
          case 'ciudadTexting':
            this.ciudadTexting = true
            break
          case 'addressLevelTopTexting':
            this.addressLevelTopTexting = true
            break
          case 'addressLevelMiddleTexting':
            this.addressLevelMiddleTexting = true
            break
          case 'addressLevelBottomTexting':
            this.addressLevelBottomTexting = true
            break
        }
      }
      if (document.getElementById(event).value == '') {
        switch (type) {
          case 'nombreTexting':
            this.nombreTexting = false
            break
          case 'apellidoTexting':
            this.apellidoTexting = false
            break
          case 'cuilTexting':
            this.cuilTexting = false
            break
          case 'dniTexting':
            this.dniTexting = false
            break
          case 'legajoTexting':
            this.legajoTexting = false
            break
          case 'mailTexting':
            this.mailTexting = false
            break
          case 'celularTexting':
            this.celularTexting = false
            break
          case 'emergenciaTexting':
            this.emergenciaTexting = false
            break
          case 'cbuTexting':
            this.cbuTexting = false
            break
          case 'calleTexting':
            this.calleTexting = false
            break
          case 'direccionTexting':
            this.direccionTexting = true
            break
          case 'ciudadTexting':
            this.ciudadTexting = false
            break
          case 'numeroTexting':
            this.numeroTexting = false
            break
          case 'codigoPostalTexting':
            this.codigoPostalTexting = true
            break
          case 'addressLevelTopTexting':
            this.addressLevelTopTexting = false
            break
          case 'addressLevelMiddleTexting':
            this.addressLevelMiddleTexting = false
            break
          case 'addressLevelBottomTexting':
            this.addressLevelBottomTexting = true
            break
        }
      }
      if (field.name) {
        let fieldChanged =
          '{"name":"' + field.name + '","value":"' + field.value + '"}'
        let auxFieldChanged = JSON.parse(fieldChanged)
        this.fieldsInChange.forEach((element, index) => {
          let auxElement = JSON.parse(element)
          if (auxElement.name == auxFieldChanged.name) {
            this.fieldsInChange.splice(index, 1)
          }
        })
        this.fieldsInChange.push(fieldChanged)
      }
    },
    handleChangeFami(event, second) {
      if (this.employeeState != 3) {
        if (event) {
          let fieldChanged = '{"name":"' + event + '","value":"' + second + '"}'
          this.fieldsInChange.push(fieldChanged)
        }
      }
    },
    handlerCBU(event) {
      let that = this
      if (event.type == 'aplica') {
        if (event.value == true) {
          that.showCbu = true
          let fieldChanged =
            '{"name":"' + event.name + '","value":' + event.value + '}'
          this.fieldsInChange.push(fieldChanged)
        } else {
          that.showCbu = false
          let fieldChanged = '{"name":"' + event.name + '","value":false}'
          this.fieldsInChange.push(fieldChanged)
        }
      }
    },
    handlerChangeSubmit(field) {
      let fieldsInChangeStringify =
        '[' + JSON.parse(JSON.stringify(this.fieldsInChange)).toString() + ']'
      if (fieldsInChangeStringify != '[]') {
        this.ob
          .putInfoPersonal(this.$route.params.id, fieldsInChangeStringify)
          .then((res) => {
            if (res.status === 200) {
              this.isLoading = false
              swal({
                title: this.$t('message.employee_edit_success').toString(),
                reverseButtons: false,
                type: 'success',
                confirmButtonColor: '#0091b0',
                confirmButtonText: this.$t(
                  'message.employee_confirm'
                ).toString()
              })
              // this.bus.$emit('handlerStatistics');
              this.$emit('stateChanged', this.fieldsInChange)
              this.searchStatistics(this.$route.params.id)
              if (field != undefined) this.buttonsDocuments(field, 'toPill')

              this.fieldsInChange = []
              this.initState()
            }
          })
          .catch((error) => {
            this.isLoading = false
            this.fieldsInChange = []
            // this.bus.$emit('handlerStatistics');
            this.$emit('stateChanged', this.fieldsInChange)
            this.searchStatistics(this.$route.params.id)
            this.initState()
            swal({
              title: this.$t('message.swal_error').toString(),
              reverseButtons: false,
              type: 'error',
              confirmButtonColor: '#0091b0',
              confirmButtonText: this.$t('message.employee_confirm').toString()
            })
          })
      }
    },
    initState() {
      this.disabledInfoPersonal = false
      this.isEditingDoc = false
      this.isEditingParent = false
    },
    validateFamily(item, marca, index) {
      let subfieldFamily = _.filter(
        this.config.sections[2].levels[0].fields[0].subfields,
        (subfield, key) => {
          if (subfield.use === true && subfield.mandatory === true) {
            return subfield
          }
        }
      )
      let valuesFamily = _.filter(subfieldFamily, (s, k) => {
        return (
          item[s.name + '_' + index] == '' ||
          item[s.name + '_' + index] === undefined
        )
      })
      return valuesFamily.length == 0
    },
    validateDoc(item, marca) {
      if (item.use === true) {
        if (
          (item.mandatory === false &&
            (item.value === false || item.value == null)) ||
          item.mandatory === true
        ) {
          let subfieldSUeTrue = _.filter(item.subfields, (subfield, key) => {
            return (
              subfield.use === true &&
              subfield.mandatory === true &&
              (subfield.value == '' || subfield.value == undefined)
            )
          })
          return subfieldSUeTrue.length == 0
        }
      }
    },
    childrenIndex(parentesco) {
      if (parentesco === 'hijo' && this.counter < 10) {
        let children = ++this.counter
        return parentesco + ' ' + children
      } else {
        return parentesco
      }
    },
    buildSearch() {
      this.tmp = []
      _.each(this.config.sections[3].values, (value) => {
        this.tmp.push(value.iddoc)
      })
      this.qrySearchInit =
        '{"where":[{"fields":[{"operator":"in","alias":"id","value":[' +
        this.tmp +
        ']}]}]}'
      this.ap
        .SearchEforms('documento', this.qrySearchInit)
        .then((res) => {
          if (res.status === 200) {
            this.eform = res.data.results.data
            this.initInputs()
          }
        })
        .catch((error) => {})
    },
    isImage(arr, type) {
      if (type === 'img') {
        let itemImg = arr.subfields.filter((item) => item.type === 'Image')
        return itemImg
      } else if (type === 'notImg') {
        let item = arr.subfields.filter((item) => item.type !== 'Image')
        return item
      }
    },
    DocumentPdf(app, appdoc, type, page) {
      this.ef.client.getDocumentPdf(app, appdoc, type, page)
    },
    initInputs() {
      if (document.getElementById('user.cuil').value == null)
        this.cuilTexting = false
      if (document.getElementById('user.numero_legajo').value == '')
        this.legajoTexting = false
      if (document.getElementById('user.nombre').value == '')
        this.nombreTexting = false
      if (document.getElementById('user.apellido').value == '')
        this.apellidoTexting = false
      if (document.getElementById('user.dni').value == '')
        this.dniTexting = false
      if (document.getElementById('user.mail').value == '')
        this.mailTexting = false
      if (document.getElementById('celular').value == '')
        this.celularTexting = false
      if (document.getElementById('celular_emergencia').value == '')
        this.emergenciaTexting = false
      if (document.getElementById('calle').value == '')
        this.calleTexting = false
      if (document.getElementById('numero').value == '')
        this.numeroTexting = false
      if (document.getElementById('codigopostal').value == '')
        this.codigoPostalTexting = false
      if (document.getElementById('ciudad').value == '')
        this.ciudadTexting = false
      if (document.getElementById('address_level_top').value == '')
        this.addressLevelTopTexting = false
      if (document.getElementById('address_level_middle').value == '')
        this.addressLevelMiddleTexting = false
      if (document.getElementById('address_level_bottom').value == '')
        this.addressLevelBottomTexting = false
      if (document.getElementById('cbu').value == '') this.cbuTexting = false
    },
    groupDocuments(box, arrow) {
      let boxContent = document.getElementById(box)
      let arrowContentUp = document.getElementById(box + 'up')
      let arrowContentDown = document.getElementById(box + 'down')
      if (arrow == 'up') {
        boxContent.classList.add('d-none')
        arrowContentDown.classList.remove('d-none')
        arrowContentUp.classList.add('d-none')
      }
      if (arrow == 'down') {
        boxContent.classList.remove('d-none')
        arrowContentDown.classList.add('d-none')
        arrowContentUp.classList.remove('d-none')
      }
    },
    buttonsDocuments(field, to) {
      let name = field.name
      let showButtons = document.getElementById(name + 'toSave')
      let showPills = document.getElementById(name + 'toPill')
      if (to == 'toPill') {
        showButtons.classList.remove('d-none')
        showPills.classList.add('d-none')
      }
      if (to == 'toSave') {
        showButtons.classList.add('d-none')
        showPills.classList.remove('d-none')
      }
    },
    rangeArray(idPill, idBox) {
      let arrowUp = idBox + 'up'
      let arrowDown = idBox + 'down'
      if (document.getElementById(idPill) != null) {
        if (document.getElementById(idPill).classList != null) {
          let elemento = document.getElementById(idPill).classList
          elemento.forEach((element) => {
            if (element == 'm-porlet-info-complete') {
              let box = document.getElementById(idBox)
              let hideArrowUp = document.getElementById(arrowUp)
              let showArrowDown = document.getElementById(arrowDown)
              box.classList.remove('d-none')
              showArrowDown.classList.add('d-none')
              hideArrowUp.classList.remove('d-none')
            }
          })
        }
      }
    },
    beginDocuments() {
      this.rangeArray('infocvtoSave', 'infocv')
      this.rangeArray('infoconstanciacuiltoSave', 'infoconstanciacuil')
      this.rangeArray('infocertestudiotoSave', 'infocertestudio')
      this.rangeArray('infoconstanciacbutoSave', 'infoconstanciacbuto')
      this.rangeArray('constanciadecbutoSave', 'constanciadecbu')
      this.rangeArray('infocontratofirmadotoSave', 'infocontratofirmado')
      this.rangeArray('infodnitoSave', 'infodni')
      this.rangeArray('hijodni_1toSave', 'hijodni_1')
      this.rangeArray('hijodni_2toSave', 'hijodni_2')
      this.rangeArray('hijodni_3toSave', 'hijodni_3')
      this.rangeArray('hijodni_4toSave', 'hijodni_4')
      this.rangeArray('hijodni_5toSave', 'hijodni_5')
      this.rangeArray('hijodni_6toSave', 'hijodni_6')
      this.rangeArray('hijodni_7toSave', 'hijodni_7')
      this.rangeArray('hijodni_8toSave', 'hijodni_8')
      this.rangeArray('hijodni_9toSave', 'hijodni_9')
      this.rangeArray('hijodni_10toSave', 'hijodni_10')
      this.rangeArray('familydni_1toSave', 'familydni_1')
      this.rangeArray('familydni_2toSave', 'familydni_2')
      this.rangeArray('marriage_certificate_1toSave', 'marriage_certificate_1')
      this.rangeArray('marriage_certificate_2toSave', 'marriage_certificate_2')
      this.rangeArray('certantpenalestoSave', 'certantpenales')
      this.rangeArray('matriculatoSave', 'matricula')
      this.rangeArray('carnetconducirtoSave', 'carnetconducir')
    },
    searchStatistics(id) {
      this.op
        .getStatistics(id)
        .then((res) => {
          if (res.status === 200 && res.data && res.data[0]) {
            this.setObStats(res.data[0])
          }
        })
        .catch((error) => {})
    },
    setObStats(statsData) {
      if (!statsData) return
      if (statsData.datos_personales) {
        this.obstats.personalData.items_obligatorios_completos =
          statsData.datos_personales.items_obligatorios_completos
        this.obstats.personalData.items_obligatorios_totales =
          statsData.datos_personales.items_obligatorios_totales
      }
      if (statsData.section_documentos) {
        this.obstats.documentData.items_obligatorios_completos =
          statsData.section_documentos.items_obligatorios_completos
        this.obstats.documentData.items_obligatorios_totales =
          statsData.section_documentos.items_obligatorios_totales
      }
      if (statsData.seccion_eforms) {
        this.obstats.eformData.items_obligatorios_completos =
          statsData.seccion_eforms.items_obligatorios_completos
        this.obstats.eformData.items_obligatorios_totales =
          statsData.seccion_eforms.items_obligatorios_totales
      }
    },
    inputSichernPeopleIntegration(fieldName) {
      return (
        fieldName === 'section_personales_genero' ||
        fieldName === 'domicilio_calle' ||
        fieldName === 'domicilio_numero' ||
        fieldName === 'domicilio_piso' ||
        fieldName === 'domicilio_departamento' ||
        fieldName === 'domicilio_codigo_postal'
      )
    },
    getCountries() {
      this.vi
        .getCountries()
        .then((res) => {
          this.countriesVP = res.data.data
        })
        .catch((error) => {})
    },
    getProvinces(id) {
      this.provinceDisabled = true
      this.vi
        .getStates(id)
        .then((res) => {
          this.provincesVP = res.data.data
          this.provinceDisabled = false
        })
        .catch((error) => {
          this.provinceDisabled = false
        })
    },
    getCounties(params) {
      this.countiesDisabled = true
      this.vi
        .getCounties(params)
        .then((res) => {
          this.dataVp['domicilio_counties'] = res.data.data
          this.countiesDisabled = false
        })
        .catch((error) => {
          this.countiesDisabled = false
        })
    },
    getCities(ids) {
      this.cityDisabled = true
      this.vi
        .getCities(ids)
        .then((res) => {
          this.citiesVP = res.data.data
          this.cityDisabled = false
        })
        .catch((error) => {
          this.cityDisabled = false
        })
    },
    async getVia() {
      const {
        data: { data }
      } = await this.vi.getVia()
      this.dataVp['domicilio_via'] = data
    },
    async getZona() {
      const {
        data: { data }
      } = await this.vi.getZone()
      this.dataVp['domicilio_zona'] = data
    },
    getMaritalStatus() {
      this.maritalStatusDisabled = true
      this.vi
        .getMaritalstatus()
        .then((res) => {
          this.maritalStatusVP = res.data.data
          this.maritalStatusDisabled = false
        })
        .catch((error) => {
          this.maritalStatusDisabled = false
        })
    },
    getAddressTypes() {
      this.addressTypeDisabled = true
      this.vi
        .getAddressTypes()
        .then((res) => {
          this.addressTypesVP = res.data.data
          this.addressTypeDisabled = false
        })
        .catch((error) => {
          this.addressTypeDisabled = false
        })
    },
    getNationalities() {
      this.nationalityDisabled = true
      this.vi
        .getNationalities()
        .then((res) => {
          this.nationalitiesVP = res.data.data
          this.nationalityDisabled = false
        })
        .catch((error) => {
          this.nationalityDisabled = false
        })
    },
    vpViaConfig(field) {
      if (field.name === 'domicilio_via') {
        if (!this.vpConfigState.domicilio_via && field.value_id) {
          this.vpConfigState.domicilio_via = this.dataVp.domicilio_via.find(
            (via) => {
              return via.id === parseInt(field.value_id)
            }
          )
        }
        return true
      }
    },
    vpZonaConfig(field) {
      if (field.name === 'domicilio_zona') {
        if (!this.vpConfigState.domicilio_zona && field.value_id) {
          this.vpConfigState.domicilio_zona = this.dataVp.domicilio_zona.find(
            (zona) => {
              return zona.id === parseInt(field.value_id)
            }
          )
        }
        return true
      }
    },
    vpCountiesConfig(field) {
      if (field.name === 'domicilio_counties') {
        if (!this.vpConfigState.domicilio_counties && field.value_id) {
          this.vpConfigState.domicilio_counties =
            this.dataVp.domicilio_counties.find((countie) => {
              return countie.id === parseInt(field.value_id)
            })
        }
        return true
      }
    },
    vpDistritoConfig(field) {
      if (field.name === 'domicilio_distrito') {
        if (!this.vpConfigState.domicilio_distrito && field.value_id) {
          this.vpConfigState.domicilio_distrito = this.citiesVP.find((city) => {
            return city.id === parseInt(field.value_id)
          })
        }

        return true
      }
    },
    vpHasCountry(field) {
      if (field.name === 'domicilio_pais') {
        if (!this.countryVPSelected && field.value_id) {
          this.countryVPSelected = this.countriesVP.find((country) => {
            return country.id === parseInt(field.value_id)
          })
          this.getProvinces(parseInt(field.value_id))
        }
        return true
      }
    },
    vpHasProvince(field) {
      if (field.name === 'domicilio_provincia') {
        if (!this.provinceVPSelected && field.value_id) {
          this.provinceVPSelected = this.provincesVP.find((state) => {
            return state.id === parseInt(field.value_id)
          })
          const params = {
            idCountry: parseInt(this.countryVPSelected.id),
            idState: parseInt(field.value_id)
          }
          this.getCities(params)

          if (this.$store.state.user.pais === 'PE') {
            this.getCounties(params)
          }
        }
        return true
      }
    },
    vpHasCity(field) {
      if (field.name === 'domicilio_localidad') {
        if (!this.cityVPSelected && field.value_id) {
          this.cityVPSelected = this.citiesVP.find((city) => {
            return city.id === parseInt(field.value_id)
          })
        }
        return true
      }
    },
    vpHasMaritalStatus(field) {
      if (field.name === 'section_personales_estado_civil') {
        if (!this.maritalStatusVPSelected && field.value_id) {
          this.maritalStatusVPSelected = this.maritalStatusVP.find((status) => {
            return status.id === parseInt(field.value_id)
          })
        }
        return true
      }
    },
    vpHasAddressType(field) {
      if (field.name === 'domicilio_tipo_domicilio') {
        if (!this.addressTypeVPSelected && field.value_id) {
          this.addressTypeVPSelected = this.addressTypesVP.find((type) => {
            return type.id === parseInt(field.value_id)
          })
        }
        return true
      }
    },
    vpHasNationality(field) {
      if (field.name === 'section_personales_nacionalidad') {
        if (!this.nationalityVPSelected && field.value_id) {
          this.nationalityVPSelected = this.nationalitiesVP.find((type) => {
            return type.id === parseInt(field.value_id)
          })
        }
        return true
      }
    },
    handleChangeCountryVP(field) {
      this.disabledInfoPersonal = true
      this.getProvinces(this.countryVPSelected.id)
      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.countryVPSelected.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.countryVPSelected.id}" }`
          this.fieldsInChange.push(valueId)
        }

        if (field.hasOwnProperty('refresh')) {
          field.refresh.forEach((e) =>
            this.fieldsInChange.push(
              `{ "name": "${e}", "value": "" },{ "name": "${e}", "value_id": "" }`
            )
          )
        }

        this.provinceVPSelected = {}
        this.cityVPSelected = {}

        if (this.$store.state.user.pais === 'PE') {
          this.vpConfigState.domicilio_distrito = {}
          this.vpConfigState.domicilio_counties = {}
        }
      }
    },
    handleChangeProvincesVP(field) {
      this.disabledInfoPersonal = true

      let params = {
        idCountry: parseInt(this.countryVPSelected.id),
        idState: parseInt(this.provinceVPSelected.id)
      }
      this.getCities(params)

      if (this.$store.state.user.pais === 'PE') {
        this.getCounties(params)
      }

      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.provinceVPSelected.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.provinceVPSelected.id}" }`
          this.fieldsInChange.push(valueId)
        }

        if (field.hasOwnProperty('refresh')) {
          field.refresh.forEach((e) =>
            this.fieldsInChange.push(
              `{ "name": "${e}", "value": "" },{ "name": "${e}", "value_id": "" }`
            )
          )
        }

        this.cityVPSelected = {}

        if (this.$store.state.user.pais === 'PE') {
          this.vpConfigState.domicilio_distrito = {}
          this.vpConfigState.domicilio_counties = {}
        }
      }
    },
    handleChangeCountiesVP(field) {
      this.disabledInfoPersonal = true

      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.vpConfigState.domicilio_counties.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.vpConfigState.domicilio_counties.id}" }`
          this.fieldsInChange.push(valueId)
        }

        if (field.hasOwnProperty('refresh')) {
          field.refresh.forEach((e) =>
            this.fieldsInChange.push(
              `{ "name": "${e}", "value": "" },{ "name": "${e}", "value_id": "" }`
            )
          )
        }
      }
    },
    handleChangeCitiesVP(field) {
      this.disabledInfoPersonal = true

      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.cityVPSelected.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.cityVPSelected.id}" }`
          this.fieldsInChange.push(valueId)
        }

        if (field.hasOwnProperty('refresh')) {
          field.refresh.forEach((e) =>
            this.fieldsInChange.push(
              `{ "name": "${e}", "value": "" },{ "name": "${e}", "value_id": "" }`
            )
          )
        }
      }
    },
    handleChangeDistritoVP(field) {
      this.disabledInfoPersonal = true

      if (field.name) {
        const fieldChanged = `{"name":"${field.name}","value":"${this.vpConfigState.domicilio_distrito.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.vpConfigState.domicilio_distrito.id}" }`
          this.fieldsInChange.push(valueId)
        }

        if (field.hasOwnProperty('refresh')) {
          field.refresh.forEach((e) =>
            this.fieldsInChange.push(
              `{ "name": "${e}", "value": "" },{ "name": "${e}", "value_id": "" }`
            )
          )
        }
      }
    },
    handleChangeMaritalStatusVP(field) {
      this.disabledInfoPersonal = true

      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.maritalStatusVPSelected.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.maritalStatusVPSelected.id}" }`
          this.fieldsInChange.push(valueId)
        }
      }
    },
    handleChangeViaVP(field) {
      this.disabledInfoPersonal = true

      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.vpConfigState.domicilio_via.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.vpConfigState.domicilio_via.id}" }`
          this.fieldsInChange.push(valueId)
        }
      }
    },
    handleChangeZonaVP(field) {
      this.disabledInfoPersonal = true

      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.vpConfigState.domicilio_zona.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.vpConfigState.domicilio_zona.id}" }`
          this.fieldsInChange.push(valueId)
        }
      }
    },
    handleChangeAddressTypeVP(field) {
      this.disabledInfoPersonal = true

      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.addressTypeVPSelected.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.addressTypeVPSelected.id}" }`
          this.fieldsInChange.push(valueId)
        }
      }
    },
    handleChangeNationalityVP(field) {
      this.disabledInfoPersonal = true

      if (field.name) {
        let fieldChanged = `{"name":"${field.name}","value":"${this.nationalityVPSelected.description}"}`
        this.fieldsInChange = this.fieldsInChange.filter((element, index) => {
          return !element.includes(field.name)
        })

        this.fieldsInChange.push(fieldChanged)

        if (field.hasOwnProperty('value_id')) {
          let valueId = `{ "name": "${field.name}", "value_id": "${this.nationalityVPSelected.id}" }`
          this.fieldsInChange.push(valueId)
        }
      }
    }
  },
  watch: {
    resetData(newValue, oldValue) {
      if (newValue) {
        this.getEmployeeById()
        this.searchStatistics(this.$route.params.id)
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import './public/assets/scss/components/_onboarding.scss';
</style>
